import React from 'react'

import { ApolloProvider } from '@apollo/client'

import Tools from './Tools'
import { client } from '../../apollo'
import MaterialUiProvider from '../MaterialUiProvider'

export default function ToolsPage({ cspNonce }: { cspNonce: string }) {
  return (
    <ApolloProvider client={client}>
      <MaterialUiProvider cspNonce={cspNonce}>
        <h1>Tools</h1>
        <Tools />
      </MaterialUiProvider>
    </ApolloProvider>
  )
}
